import React from "react";
import Navigator from "../../../components/navigator/Navigator";

export const DeletePhoneNumberFromMBS = ({ id }: { id: string }) => {
    return (
        <>
            <div className="description">
                How to Delete a Phone Number from WhatsApp in Meta Business Suite
            </div>

            <div className="sub-section">
                <ol>
                    <li>
                        <div>
                        <div>Log in to Meta Business Suite</div>
                        Go to business.facebook.com
                        and sign in with the account that manages your WhatsApp Business.
                        </div>
                    </li>
                    <li>
                        <div>
                        <div>Access Business Settings</div>
                        From the left-hand menu, click Settings → Business Settings.
                        </div>
                    </li>

                    <li>
                        <div>
                        <div>Open WhatsApp Accounts</div>
                        Under Accounts, select WhatsApp Accounts.
                        You will see the phone numbers connected to your business.
                        </div>
                    </li>

                    <li>
                        <div>
                        <div>Remove the Phone Number</div>
                        Select the phone number that’s causing issues.
                        Click Settings → Phone Numbers, then choose Delete / Remove to disconnect it from Meta.
                        </div>
                    </li>

                    <li>
                        <div>
                        <div>Wait Before Reconnecting</div>
                        After deleting, wait 5–10 minutes to allow Meta to fully clear the number from offline mode.
                        </div>
                    </li>

                    <li>
                        <div>
                        <div>Reconnect via Vuelve</div>
                        Go back to your Vuelve dashboard and re-add the phone number.
                        This time, it will be added successfully in Online state.
                        </div>
                    </li>
                </ol>
            </div>
        </>
    );
}